import React from "react";
import styles from "./GiveawayBanner.module.css";
import dreamcoinLogo from "/DC_coin.svg";
import CharacterLogo from "/character-circle-gold.svg";
import telegramNFTLogo from "/telegramNFT.svg";
import { MainPrize } from "../../types";

interface GiveawayBannerProps {
  background: string;
  mainPrizes: MainPrize[];
}

const GiveawayBanner: React.FC<GiveawayBannerProps> = ({
  background,
  mainPrizes,
}) => {
  const formatNumber = (num: number): string => {
    return num.toLocaleString("en-US");
  };

  return (
    <div className={styles.bannerContainer}>
      <img
        src={background}
        alt="Giveaway Banner"
        className={
          styles.bannerImage +
          " " +
          (mainPrizes[0].type === "TelegramNFT" ? styles.bannerImageNFT : "")
        }
      />
      <div className={styles.bannerOverlay}></div>
      <div className={styles.prizeContainer}>
        {mainPrizes.map((prize, index) => (
          <div className={styles.prizeInfo} key={index}>
            {prize.type === "Character" || prize.type === "TelegramNFT" ? (
              ""
            ) : (
              <div className={styles.prizeAmount}>
                {formatNumber(prize.amount)}
              </div>
            )}
            <div className={styles.prizeType}>
              {prize.type === "Character"
                ? "Легендарный"
                : prize.type === "TelegramNFT"
                ? "Подарки"
                : prize.type}
            </div>
            <div className={styles.prizeIcon}>
              {prize.type === "DC" ? (
                <img src={dreamcoinLogo} alt="" />
              ) : prize.type === "TelegramNFT" ? (
                <img src={telegramNFTLogo} alt="" />
              ) : (
                <img src={CharacterLogo} alt="" />
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default GiveawayBanner;
